module.exports = __webpack_public_path__ + "static/gmail-8c5fb0c74a0fa5c5d96501464c1e5484.svg";